// extracted by mini-css-extract-plugin
module.exports = {"dropdown_section_wrapper":"dropdown-section_dropdown_section_wrapper__N0u7G"};